(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    var recommended_url = productRecommendationsSection.dataset.baseUrl;;

    if (productRecommendationsSection === null) { return; }
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;
    // Build request URL
    var requestUrl = recommended_url + '?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        var contents = container.querySelector(".product-recommendations");
        var scripts = contents.getElementsByClassName("swatches_hover");                                           
                                           
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
                                                        
		var prodColors = document.getElementsByClassName("prod-colors");
		for(var i = 0; i < prodColors.length; i++) {
            var script = document.createElement("script");
            script.innerHTML = scripts[i].innerHTML;
        	prodColors[i].appendChild(script);
       	}
        
        productQuickView();
      }
    };
    request.send();
  };
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();
                                                        
  var productQuickView = function() {
    var products = $('.product__related-container .product-index');

    $(products).each(function( index ) {
      var id = $( this ).data('productId');
      var quickView = $('[data-fancybox="quick-view-' + id + '"]');

      quickView.fancybox({
         type : 'ajax',
         toolbar: false,
         infobar: false,
         arrows: false,
         touch: false,
         autoFocus: false,
         iframe : {
          preload: true,
          css : {
            width : '800px'
          }
         },
         baseClass: 'quickview-popup',
         afterShow: function () {
            var context = document.querySelector(".product-quick-view");
            Events.trigger("quickview:load", context);
           // Close fancybox after add to cart
           Events.on("ajaxcart:cartUpdate", function() {
             $.fancybox.close()
           });
         }
       });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
